import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { Text } from '@naf/text';
import { GridCol } from '@naf/grid';

export const ButtonContainer = styled.div`
  display: flex;
  text-align: center;
  margin-top: ${spacing.space40};
  margin-bottom: ${spacing.space48};
  gap: ${spacing.space24};

  @media (max-width: ${breakpoints.l}) {
    flex-direction: column;
  }

  @media (max-width: ${breakpoints.s}) {
    margin-bottom: ${spacing.space40};

    button,
    a {
      width: 100%;
    }
  }
`;

export const HeaderText = styled(Text)`
  margin-bottom: -${spacing.space24};
`;

export const ImageGridColumn = styled(GridCol)`
  margin-top: ${spacing.space24};
  width: auto;
  height: 313px;
`;
